import { useEffect, useRef, useState } from "react";

const faqs = [
  {
    question: "Чи не зупинить впровадження наш поточний найм?",
    answer:
      "Ні, запуск можна почати з одного регіону, категорії вакансій або етапу воронки. HURMA допомагає налаштувати процес так, щоб рекрутери продовжували працювати без паузи.",
  },
  {
    question: "Хто бере на себе ризик впровадження?",
    answer:
      "Команда HURMA супроводжує запуск: допомагає з воронками, ролями, доступами, міграцією, інтеграціями й навчанням команди. HRD не лишається сам на сам із впровадженням.",
  },
  {
    question: "Як працювати з кандидатами без резюме?",
    answer:
      "Для лінійного найму достатньо простої заявки: ім'я, телефон, місто, бажана позиція, базові відповіді. HURMA фіксує кандидата в системі й веде його по воронці без потреби в повному резюме.",
  },
  {
    question: "А якщо рекрутерам складно працювати в нових системах?",
    answer:
      "HURMA показує рекрутеру конкретні дії: новий кандидат, статус, дзвінок, коментар, наступний крок. Під час запуску команда HURMA навчає користувачів і допомагає адаптувати процес під реальну роботу команди.",
  },
  {
    question: "Чи інтегрується HURMA з нашими внутрішніми системами?",
    answer:
      "Так. HURMA має API та може підключатися до систем обліку, навчання й аналітики, які використовує мережа.",
  },
  {
    question: "Скільки це коштує?",
    answer:
      "Ціна залежить від масштабу мережі, кількості користувачів, потрібних модулів, інтеграцій і аналітики. На аудиті покажемо, де зараз губляться кандидати, скільки коштує простій вакансії та яку економію може дати автоматизація.",
  },
  {
    question: "А якщо кандидатів просто мало?",
    answer:
      "HURMA не замінює канали залучення, але допомагає не втрачати тих, хто вже відгукнувся, швидше відповідати й бачити, які джерела реально приводять людей. Якщо зовнішній потік слабкий, AI-інструменти можуть допомогти переглянути стару базу кандидатів і знайти тих, хто підходить на поточні вакансії.",
  },
];

export default function FaqSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = entry.target.querySelectorAll(".faq-animate");
            children.forEach((child, i) => {
              setTimeout(() => child.classList.add("visible"), i * 80);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="faq"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-[#f5f5f7] overflow-hidden"
    >
      <div className="max-w-[720px] mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="faq-animate animate-on-scroll text-[32px] sm:text-[40px] lg:text-[48px] font-semibold leading-[1.1] tracking-tight text-[#1d1d1f]">
            Поширені
            <br />
            <span className="text-[#86868b]">питання</span>
          </h2>
        </div>

        <div className="flex flex-col gap-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className={`rounded-2xl transition-all duration-300 ${
                  isOpen ? "bg-white" : "bg-white/60"
                }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between p-5 lg:p-6 text-left"
                >
                  <span className="text-[17px] font-medium text-[#1d1d1f] pr-4">
                    {faq.question}
                  </span>
                  <i className={`ri-arrow-down-s-line text-[20px] text-[#86868b] flex-shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    isOpen ? "max-h-96" : "max-h-0"
                  }`}
                >
                  <div className="px-5 lg:px-6 pb-5 lg:pb-6">
                    <p className="text-[15px] text-[#86868b] leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}